module.exports = __webpack_public_path__ + "static/img/jszg_img_hxkd_content.d7f2314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jszg_img_hxkd_content.png
// module id = ktEj
// module chunks = 0